export default function searchVisibilityTracker(IntersectionObserverInjected) {
  return App.components.page_visibility_tracker(IntersectionObserverInjected);
}

export const visibilityTracker = searchVisibilityTracker().init();
